import { useMemberSystem } from "@/pages/profile/components/profile-charge-card/components/member-system/hooks/useMemberSystem";
import styled, { css } from "styled-components";

import Msbg0 from "@/assets/images/msbg-0.png";
import MsbgSub0 from "@/assets/images/msbg-0-sub.png";
import Msbg1 from "@/assets/images/msbg-1.png";
import MsbgSub1 from "@/assets/images/msbg-1-sub.png";
import Msbg49 from "@/assets/images/msbg-49.png";
import MsbgSub49 from "@/assets/images/msbg-49-sub.png";
import Msbg55 from "@/assets/images/msbg-55.png";
import MsbgSub55 from "@/assets/images/msbg-55-sub.png";
import Msbg56 from "@/assets/images/msbg-56.png";
import MsbgSub56 from "@/assets/images/msbg-56-sub.png";
import Msbg57 from "@/assets/images/msbg-57.png";
import MsbgSub57 from "@/assets/images/msbg-57-sub.png";
import Msbg58 from "@/assets/images/msbg-58.png";
import MsbgSub58 from "@/assets/images/msbg-58-sub.png";
import Msbg59 from "@/assets/images/msbg-59.png";
import Msbg60 from "@/assets/images/msbg-60.png";
import Msbg60Sub from "@/assets/images/msbg-60-sub.png";
// en
import Msbg0En from "@/assets/images/msbg-en-0.png";
import MsbgEnSub0 from "@/assets/images/msbg-0-en-sub.png";
import Msbg1En from "@/assets/images/msbg-en-1.png";
import MsbgEnSub1 from "@/assets/images/msbg-1-en-sub.png";
import Msbg49En from "@/assets/images/msbg-49-en.png";
import MsbgEnSub49 from "@/assets/images/msbg-49-en-sub.png";
import Msbg55En from "@/assets/images/msbg-55-en.png";
import MsbgEnSub55 from "@/assets/images/msbg-55-en-sub.png";
import Msbg56En from "@/assets/images/msbg-56-en.png";
import MsbgEnSub56 from "@/assets/images/msbg-56-en-sub.png";
import Msbg57En from "@/assets/images/msbg-57-en.png";
import MsbgEnSub57 from "@/assets/images/msbg-57-en-sub.png";
import Msbg58En from "@/assets/images/msbg-58-en.png";
import MsbgEnSub58 from "@/assets/images/msbg-58-en-sub.png";
import Msbg59En from "@/assets/images/msbg-59-en.png";
import Msbg60En from "@/assets/images/msbg-60-en.png";
import Msbg60SubEn from "@/assets/images/msbg-60-en-sub.png";
import {
  InnerProgress,
  ProfileCard,
  ProgressBar,
  GapLine,
} from "../../../atom";
import { useTranslation } from "react-i18next";
import { getMemberLevelTranslate } from "@/pages/profile/helper/getMemberLevelTranslate";
import { useGlobalStore } from "@/store/GlobalStore";
import { Fragment } from "react";
import dayjs from "dayjs";
import Coupon4Icon from "@/assets/icons/profile/coupon-4";
import Discount5Icon from "@/assets/icons/profile/discount-5";
import Top20Icon from "@/assets/icons/profile/top-20";
import RenderSampleIcon from "@/assets/icons/profile/render-sample";
import { isEn } from "project-config/utils/env";
import { Tooltip } from "antd";
import { UserLevel, Whether } from "project-config/constants";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import { getTranslateNsT } from "@/utils/getTranslateNsT";

const MemberLevelBgImgMap: { [_: string]: string[] } = {
  0: [Msbg0, Msbg0En, MsbgSub0, MsbgEnSub0],
  1: [Msbg1, Msbg1En, MsbgSub1, MsbgEnSub1],
  49: [Msbg49, Msbg49En, MsbgSub49, MsbgEnSub49],
  55: [Msbg55, Msbg55En, MsbgSub55, MsbgEnSub55],
  56: [Msbg56, Msbg56En, MsbgSub56, MsbgEnSub56],
  57: [Msbg57, Msbg57En, MsbgSub57, MsbgEnSub57],
  58: [Msbg58, Msbg58En, MsbgSub58, MsbgEnSub58],
  59: [Msbg59, Msbg59En],
  60: [Msbg60, Msbg60En, Msbg60Sub, Msbg60SubEn],
};

export function MemberSystem({
  level = 49,
  showProgress = true,
  showTotal,
  chargeClick,
  disabledRecharge = true,
}: {
  level?: number;
  showProgress: boolean;
  showTotal?: boolean;
  disabledRecharge?: boolean;
  chargeClick?: (key?: string) => void;
}) {
  const { currenProgress, progressbar, percent, nextLevel } = useMemberSystem();
  const {
    userInfo,
    currencySymbol,
    userBalance,
    isStudent,
    isStudentValid,
    isPictureUser,
    isSubAccount,
    isHaveSubAccount,
    isPersonal,
    isHideBalance,
    userSubAccountBalance,
  } = useGlobalStore();
  const { userProperty } = useUserPropertyStore();
  const _level =
    !isPictureUser && isStudent && isStudentValid && isPersonal
      ? UserLevel.DiamondStudent
      : level;
  const isPictureNormal = isPictureUser && _level === 0;
  const { t } = useTranslation("profile");
  const commonT = getTranslateNsT("common");
  const VIPExpireDate = userInfo?.picMemberValidity
    ? userInfo?.picMemberValidity
    : userInfo?.tempMemberValidityTime || 0;
  return (
    <MemberSystemCard
      height={isSubAccount ? "140px" : isPictureNormal ? "280px" : ""}
    >
      <MemberBgWrapper>
        <MemberLevelBg
          src={
            MemberLevelBgImgMap[_level][
              isSubAccount ? Number(isEn()) + 2 : Number(isEn())
            ]
          }
        />
      </MemberBgWrapper>
      <MemberLevelMain className={`level-${level}`}>
        {!isHideBalance && (
          <BalanceCreditWrapper>
            <Balance>
              <CountLabel>
                <span>
                  {" "}
                  {t(
                    !isSubAccount ? "account_balance" : "account_balance_total"
                  )}
                </span>
                {isHaveSubAccount && (
                  <>
                    <GapLine />
                    <span> {t("account_balance_total")}</span>
                    <Tooltip title={t("account_balance_total_remark")}>
                      <span className="remark">?</span>
                    </Tooltip>
                  </>
                )}
              </CountLabel>
              <CountWithSymbol>
                <div>
                  <span className="symbol">{currencySymbol}</span>
                  <span className="credit">{userBalance}</span>
                </div>
                {isHaveSubAccount && (
                  <>
                    <GapLine height={"14px"} style={{ margin: "0 12px" }} />
                    <div>
                      <span className="symbol">{currencySymbol}</span>
                      <span className="credit">
                        {userSubAccountBalance ?? 0}
                      </span>
                    </div>
                  </>
                )}
              </CountWithSymbol>
            </Balance>
          </BalanceCreditWrapper>
        )}
        {showProgress && !isSubAccount && (
          <Fragment>
            <ProgressBar>
              <CurrentProgress className={`level-${level}`} percent={percent} />
            </ProgressBar>
            <AccumulatedRechargeWrapper>
              {!isStudentValid ? (
                <span>{`${t(
                  "accumulative_recharge"
                )} ${currencySymbol}${currenProgress}`}</span>
              ) : (
                <span>{`${t("student_end_time")}${dayjs(
                  new Date(userInfo?.studentEndTime || 0)
                ).format("YYYY-MM-DD")}`}</span>
              )}
              {nextLevel >= 0 && (
                <div>
                  <span>{t("next_level_need_recharge_pre")}</span>
                  <span className="vip">
                    {getMemberLevelTranslate(nextLevel)}
                  </span>
                  <span>{t("next_level_need_recharge_sub")}</span>
                  <span>{` ${currencySymbol}${(
                    progressbar - currenProgress
                  ).toFixed(2)}`}</span>
                </div>
              )}
            </AccumulatedRechargeWrapper>
          </Fragment>
        )}
        {!isSubAccount && (
          <ChargeButton
            className={`level-${level} ${!disabledRecharge && "disabled"} ${
              !showProgress && "margin"
            }`}
            onClick={() => chargeClick && chargeClick()}
          >
            <span>
              {userProperty.isFirstRecharge === Whether.No
                ? commonT("common_new_user_recharge_btn")
                : t("recharge")}
            </span>
          </ChargeButton>
        )}
        {!showProgress && !isPictureNormal && !isSubAccount && (
          <ExpireDateWrapper>
            <div>
              <span className="label">{t("picture_end_time")}</span>
              <span className="date">
                {VIPExpireDate
                  ? dayjs(VIPExpireDate).format("YYYY-MM-DD")
                  : "-"}
              </span>
            </div>
            {!userInfo?.tempMemberValidityTime && (
              <PictureRechargeButton
                onClick={() => chargeClick && chargeClick("picture-vip-item")}
              >
                {t("picture_renewal")}
              </PictureRechargeButton>
            )}
          </ExpireDateWrapper>
        )}
        {!showProgress && isPictureNormal && !isSubAccount && (
          <PictureNormalWrapper>
            <div>
              <PictureRechargeLabel>
                <span>{t("picture_more_benefit")}</span>
                {!isSubAccount && (
                  <PictureSubscribeButton
                    onClick={() =>
                      chargeClick && chargeClick("picture-vip-item")
                    }
                  >
                    {t("picture_subscribe")}
                  </PictureSubscribeButton>
                )}
              </PictureRechargeLabel>
              <PictureRechargeItemContainer isZh={!isEn()}>
                <PictureRechargeItem className="benefit_0">
                  <Coupon4Icon />
                  <span>{t("picture_benefit_0")}</span>
                </PictureRechargeItem>
                <PictureRechargeItem className="benefit_1">
                  <Discount5Icon />
                  <span>{t("picture_benefit_5")}</span>
                </PictureRechargeItem>
                <PictureRechargeItem className="benefit_2">
                  <Top20Icon />
                  <span>{t("picture_benefit_2")}</span>
                </PictureRechargeItem>
                <PictureRechargeItem className="benefit_3">
                  <RenderSampleIcon />
                  <span>{t("picture_benefit_7")}</span>
                </PictureRechargeItem>
              </PictureRechargeItemContainer>
            </div>
          </PictureNormalWrapper>
        )}
      </MemberLevelMain>
    </MemberSystemCard>
  );
}
const MemberSystemCard = styled(ProfileCard)<{ height: string }>`
  height: ${(p) => p.height || "214px"};
  padding: 0;
  ${ProgressBar} {
    margin-top: 14px;
  }
`;

const ExpireDateWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 24px);
  height: 40px;
  bottom: 0;
  .label {
    font-size: 12px;
    color: #9ba2b0;
  }
  .date {
    color: #edf2f5;
    margin-left: 12px;
  }
`;
const PictureRechargeButton = styled.div`
  width: 66px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  color: #8b3e06;
  background: linear-gradient(280.88deg, #f3c073 12.69%, #ffe3ca 109.28%);
  border-radius: 41px;
  cursor: pointer;
`;

const PictureRechargeLabel = styled.div`
  margin: 34px 30px 14px 0;
  display: flex;
  flex-direction: column;
  span {
    width: 118px;
    font-weight: 600;
    color: #084875;
  }
`;
const PictureSubscribeButton = styled.div`
  width: 118px;
  height: 32px;
  background: linear-gradient(90.44deg, #0250e9 0%, #7000ff 100%);
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  margin-top: 8px;
`;
const PictureRechargeItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  span {
    margin-left: 6px;
  }
  &.benefit_0,
  &.benefit_2 {
    width: 120px;
  }
  &.benefit_1,
  &.benefit_3 {
    width: 135px;
  }
  &.benefit_0,
  &.benefit_1 {
    margin-bottom: 15px;
  }
`;
const PictureRechargeItemContainer = styled.div<{ isZh: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 30px 0 15px 0;
  .benefit_0,
  .benefit_1 {
    margin-bottom: 0;
  }
  .benefit_3 {
    width: 140px;
  }
  ${(p) =>
    p.isZh &&
    css`
      padding: 35px 0 21px 0;
      .benefit_0,
      .benefit_1 {
        margin-bottom: 15px;
      }
    `}
`;
const PictureNormalWrapper = styled.div`
  position: absolute;
  bottom: 0;
  height: 105px;
  width: calc(100% - 24px);
  > div {
    display: flex;
    height: 100%;
    position: relative;
  }
`;

const MemberBgWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  border-radius: 8px;
`;

const MemberLevelBg = styled.img`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
`;

const AccumulatedRechargeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 14px;
  font-size: 12px;
  font-weight: 400;
  .vip {
    font-weight: bold;
    margin: 0 4px;
  }
`;

const ChargeButton = styled.div`
  height: 36px;
  line-height: 36px;
  padding: 0 22px;
  text-align: center;
  font-size: 14px;
  border-radius: 48px;
  cursor: pointer;
  &.margin {
    margin-top: 19px;
  }
  &.disabled {
    cursor: not-allowed;
  }
  span {
    font-size: 14px;
    color: #fff;
  }
  &.level-49 {
    background: linear-gradient(
      170.29deg,
      rgba(255, 255, 255, 0.8) 7.31%,
      rgba(255, 255, 255, 0.56) 95.56%
    );
    color: #8b3e06;
    span {
      background: linear-gradient(107.56deg, #03a34c 11.11%, #08b7cf 100.34%);
      background-clip: text;
      text-fill-color: transparent;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  &.level-55 {
    background: linear-gradient(90deg, #a5c1e9 0.28%, #5083ca 99.86%);
  }
  &.level-56 {
    background: linear-gradient(280.88deg, #c26618 12.69%, #fda148 109.28%);
  }
  &.level-57 {
    background: linear-gradient(280.88deg, #3c2efe 12.69%, #7896ff 109.28%);
  }
  &.level-0 {
    background: linear-gradient(
      170.29deg,
      rgba(255, 255, 255, 0.8) 7.31%,
      rgba(255, 255, 255, 0.56) 95.56%
    );
    span {
      color: #007ad0;
    }
  }
  &.level-1 {
    background: linear-gradient(
      170.29deg,
      rgba(255, 255, 255, 0.8) 7.31%,
      rgba(255, 255, 255, 0.56) 95.56%
    );
    span {
      color: #303245;
      font-weight: 600;
    }
  }
  &.level-58,
  &.level-59,
  &.level-60 {
    background: linear-gradient(280.88deg, #f3c073 12.69%, #ffe3ca 109.28%);
    color: #8b3e06;
  }
`;

const CurrentProgress = styled(InnerProgress)`
  &.level-49 {
    background: #fff;
  }
  &.level-55 {
    background: linear-gradient(90deg, #b1c8e8 0.28%, #5083ca 99.86%);
  }
  &.level-56 {
    background: linear-gradient(280.88deg, #c26618 12.69%, #fda148 109.28%);
  }
  &.level-57 {
    background: linear-gradient(280.88deg, #3c2efe 12.69%, #7896ff 109.28%);
  }
  &.level-58,
  &.level-59,
  &.level-60 {
    background: linear-gradient(280.88deg, #f3c073 12.69%, #ffe3ca 109.28%);
  }
`;

const BalanceCreditWrapper = styled.div`
  display: flex;
  position: relative;
`;
const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
const CountWithSymbol = styled.div`
  display: flex;
  align-items: center;
  .credit {
    font-weight: 500;
    font-size: 22px;
    line-height: 25px;
    margin-left: 2px;
  }
  .symbol {
  }
`;
// const CreditCountWrapper = styled(CountWithSymbol)`
//   align-items: center;
//   gap: 8px;
// `;
const CountLabel = styled.div`
  font-size: 12px;
  display: flex;
  gap: 4px;
  align-items: center;
  opacity: 0.8;
  .remark {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.6);
    text-align: center;
    line-height: 12px;
    font-weight: bold;
    cursor: pointer;
  }
`;
const Balance = styled(FlexColumn)`
  min-width: 143px;
`;
// const Credit = styled(FlexColumn)``;

const MemberLevelMain = styled.div`
  position: absolute;
  padding: 54px 12px 16px 12px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  &.level-49 {
    color: #ffffff;
  }
  &.level-55 {
    color: #506faf;
  }
  &.level-56 {
    color: #b2530c;
  }
  &.level-57 {
    color: #372cf6;
  }
  &.level-58,
  &.level-59,
  &.level-60 {
    color: #f0cc89;
  }
`;
